import { defineAsyncComponent } from 'vue';

export default {
  components: {
    PhoenixForm: defineAsyncComponent(() => import('@maison/components/form/PhoenixForm.vue')),
  },

  props: {
    mobilePhone: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'verify',
    },
    isBoxed: {
      type: Boolean,
      default: true,
    },
    showErrorsInToast: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      fields: {
        mobilePhone: {
          name: 'mobilePhone',
          value: '',
        },
        type: {
          name: 'type',
          value: '',
        },
      },
    };
  },

  computed: {
    formAction() {
      return window.route('api.customer.phoneToken.send');
    },
  },

  watch: {
    mobilePhone: {
      handler(value) {
        this.fields.mobilePhone.value = value;
      },
      immediate: true,
    },
    type: {
      handler(value) {
        this.fields.type.value = value;
      },
      immediate: true,
    },
  },

  methods: {
    async submitForm() {
      return await this.$refs.phoenixForm.submit();
    },

    onSuccess(response) {
      this.$emit('on-success', response);
    },

    onFail(error) {
      this.$emit('on-fail', error);
    },
  },
};
